<template>
  <div class="text-center flex items-center" :class="textColor">
    <span :class="size">
      <font-awesome-icon icon="spinner" spin />
    </span>
    <span v-if="hasLabel" v-text="label" class="ml-3"></span>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: "",
      required: false,
    },
    textColor: {
      default: "text-gray-300",
      required: false,
    },
    size: {
      type: String,
      default: "text-3xl",
      required: false,
    },
  },
  components: {},
  mixins: [],
  data: function () {
    return {};
  },
  methods: {},
  computed: {
    hasLabel() {
      return this.label !== "";
    },
  },
  mounted() {},
};
</script>
